var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c("h5", { staticClass: "mr-3" }, [
            _vm._v("¿Qué son las consecuencias?")
          ]),
          _c(
            "vs-button",
            {
              staticClass: "p-3",
              attrs: { "icon-after": "", icon: "info" },
              on: {
                click: function($event) {
                  return _vm.$refs.info.show()
                }
              }
            },
            [_vm._v(" Explicación ")]
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "info",
          attrs: {
            title: "Consecuencias",
            size: "lg",
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": ""
          }
        },
        [
          _c("p", [
            _c("b", [
              _vm._v(
                " Una consecuencia es lo que sucederá con el documento que sea enviado a este flujo una vez que sea aprobado, rechazado o anulado. "
              )
            ])
          ]),
          _c("p", [
            _vm._v(" Estas consecuencias son: "),
            _c("br"),
            _c("ul", [
              _c("li", [
                _c("b", [_vm._v("1. Post Iniciado:")]),
                _vm._v(
                  " Es lo que sucede inmediatamente al ingresar o iniciar su proceso de aprobación. "
                )
              ]),
              _c("li", [
                _c("b", [_vm._v("2. Post Aprobado:")]),
                _vm._v(
                  " Es lo que sucede cuando el resultado final del flujo es aprobado. "
                )
              ]),
              _c("li", [
                _c("b", [_vm._v("3. Post Rechazado:")]),
                _vm._v(
                  " Es lo que sucede cuando el resultado final del flujo es rechazado. "
                )
              ]),
              _c("li", [
                _c("b", [_vm._v("4. Post Proceso:")]),
                _vm._v(
                  " Es lo que sucede al finalizar el flujo, sin importar el resultado. "
                )
              ]),
              _c("li", [
                _c("b", [_vm._v("5. Post Desestimado:")]),
                _vm._v(" Es lo que sucede si un flujo es anulado. ")
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }